<div class="rounded rounded-3 similar" style="height: 100%;" [class.ar-new-flow]="planInfo && planInfo.ar_flow_immediate">

  <div class="panel-outer--mainwrapper">
    <div class="col py-md-3 bg-white sidebar_plan_details d-sm-block d-xs-block" [ngClass]="{borderBottom: stepHeader}">
      <div [ngClass]="{'hide-cross': current_step>=5}">
        <app-steps class="mt-3" (triggerChangeScreen)="changeScreen()"></app-steps>
      </div>
    </div>



    <div class="rightsidepanel">
      <div class="col bg-white border__radius progress-main--wrapper"
        [ngClass]="[current_step == 7 ? 'box_personal_info_7' : '']">
        <div class="make_sticky progress-main--wrapper__left col-md-3">
          <span class="flex-grow-1 text-center" style="max-width: -webkit-fill-available;">
            <ul class="list-unstyled form-wizard-steps clearfix mb-0 mx-auto">
              <li class="activeted completeData"
                [ngClass]="current_step == 6||current_step == 7 ? '-active' :current_step == 6||current_step == 7? 'completeData':''">
                Payment Plan</li>
              <li
                [ngClass]="current_step == 6||current_step == 7 ? '-active' :current_step == 6||current_step == 7? 'completeData':''"
                class="activeted completeData">Personal Details</li>
              <li
                [ngClass]="current_step == 6||current_step == 7 ? '-active' :current_step == 6||current_step == 7? 'completeData':''"
                class="activeted completeData" *ngIf="planInfo && !planInfo.ar_flow_immediate">Recurring Details</li>
              <li class="activeted completeData" [ngClass]="current_step == 6||current_step == 7 ? '-active' : ''">Make
                Payment
              </li>
              <li class="activeted"
                [ngClass]="current_step == 6||current_step == 7 ? 'active' : current_step == 5?'completeDatas':''">
                Additional Information</li>
            </ul>
          </span>
          <div class="head_contents py-4 mb-md-3 mb-0 h5 fw-700 fs-14" *ngIf="current_step == 6">
            Your payment has been made successfully.
            <p class="contract_id_grey mt-2">
              Contract ID: {{planInfo['contract_code'] || 'Not Available'}}
            </p>
          </div>
        </div>
        <div class="box_personal_info persoan-details__wrapper" [ngClass]="{box_personal_info_5: current_step==5}">
          <div class="input_containers_head2"
            [ngClass]="[current_step == 7 ? 'justify-content-between':'justify-content-center']">
            <span *ngIf="current_step == 7">
              <span class="button_personal_back" *ngIf="current_step == 7"
                (click)="current_step = current_step - 1;getValueDates();">
                <!-- <img src="assets/png/arrow-left.png" alt="" class="hide"> -->
                <span class="show"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 23" fill="none">
                    <path d="M12 22L1 11.5L12 1" stroke="#646C70" stroke-width="1.8" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg></span>
              </span>
            </span>
          </div>

          <!-- step 1 details -->
          <ng-container *ngIf="current_step == 6">
            <div class="input_containers_head mb-0 fs-16 text--black mb-2 fw-700 final__peroandetials-formheading">
              <div class="back_button_in back_button_in_personal_info d-none pb-1 mb-4 justify-content-center"
                [ngClass]="[current_step == 7 ? 'justify-content-between':'justify-content-center']">
                <span *ngIf="current_step == 7">
                  <span
                    class="p-2 d-flex button_personal_back align-items-center jusitfy-content-center bg-white border rounded-circle"
                    role="button_close" *ngIf="current_step == 7" (click)="current_step = current_step - 1;">
                    <!-- <img src="assets/svg/back_arrow.svg" alt="" /> -->
                    <span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="23" viewBox="0 0 13 23"
                        fill="none">
                        <path d="M12 22L1 11.5L12 1" stroke="#646C70" stroke-width="1.8" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg></span>
                  </span>
                </span>
                <!-- <span class="fs-18 fw-800 px-3 mx-auto" style="margin-right: 40px;">
               Update information about yourself
                </span> -->
                <span></span>
              </div>
              <div class="heads_contents h5" *ngIf="current_step == 6">
                Your payment has been made successfully.
                <p class="contract_id_grey mt-2">
                  Contract ID: {{planInfo['contract_code'] || contract_code || 'Not Available'}}
                </p>
              </div>
              Additional Information
            </div>
            <form #personal="ngForm" (keydown.enter)="validateFirstStep(personal)"
              (ngSubmit)="validateFirstStep(personal);" class="form-part">

              <div class="is_customer_minor prsonal-info-system">
                <div class="row mx-0 py-3">
                  <span class="color-blue-black fw-400 fs-16 text--black pe-2">Is Customer a Minor?</span>
                  <div class="ps-sm-4 ps-2 d-flex align-items-center">

                    <div
                      class="yes-personal custom-radio-box left-radio-input position-relative custom-radio-checkobx me-2">
                      <input type="radio" id="yes" [checked]="patientData.is_minor == 1" name="is_minor"
                        (change)="changeFields('is_minor',1)" value="1">
                      <label class="mb-0 color-blue-black fw-700 fs-16 radio-label">Yes</label>
                    </div>

                    <div
                      class="ms-sm-4 ms-3 yes-personal custom-radio-box left-radio-input position-relative custom-radio-checkobx">
                      <input type="radio" id="no" [checked]="patientData.is_minor == 0" name="is_minor"
                        (change)="changeFields('is_minor',0)" value="0">
                      <label class="mb-0 color-blue-black fw-700 fs-16 radio-label">No</label>
                    </div>

                    <!-- <span class="yes-personal recure-payment-label position-relative pe-2">
                    <input type="radio" id="yes" class="d-none" [checked]="patientData.is_minor == 1" name="is_minor"
                      (change)="changeFields('is_minor',1)" value="1">
                    <label class="mb-0 color-blue-black fw-700 fs-16" for="yes">Yes</label>
                  </span>

                  <span class="ps-4 yes-personal">
                    <input type="radio" id="no" class="d-none" [checked]="patientData.is_minor == 0" name="is_minor"
                      (change)="changeFields('is_minor',0)" value="0">
                    <label class="mb-0 color-blue-black fw-700 fs-16" for="no">No</label>
                  </span> -->
                  </div>
                </div>
              </div>

              <div class="row height__wrapper">
                <div class="input_container col-12 col-md-6 col-sm-6 col-left-pd mt-3"
                  *ngIf="patientData.is_minor == 1">
                  <div class="flex-grow-1">


                    <div class="custom-form-v5 flex-grow-1"
                      [ngClass]="(!patientData.guardian_first_name ||  patientData.guardian_first_name.length === 0) && showvalidation?'has-error':''">
                      <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.guardian_first_name"
                        minlength="2" maxlength=25 name="guardian_first_name" required maxlength="100" />
                      <label for="text" class="label-name">
                        <span class="content-name_1 f-c-p-3">
                          Guardian First Name
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(!patientData.guardian_first_name ||  patientData.guardian_first_name.length === 0) && showvalidation">
                      Please enter guardian first name</p>
                  </div>
                </div>
                <div class="input_container col-12 col-md-6 col-sm-6 col-right-pd mt-3"
                  *ngIf="patientData.is_minor == 1">
                  <div class="flex-grow-1">
                    <div class="custom-form-v5 flex-grow-1"
                      [ngClass]="(!patientData.guardian_last_name ||  patientData.guardian_last_name.length === 0) && showvalidation?'has-error':''">
                      <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.guardian_last_name"
                        minlength="2" maxlength=25 name="guardian_last_name" required maxlength="100" />
                      <label for="text" class="label-name">
                        <span class="content-name_1 f-c-p-3">
                          Guardian Last Name
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(!patientData.guardian_last_name ||  patientData.guardian_last_name.length === 0) && showvalidation">
                      Please enter guardian last name</p>
                  </div>
                </div>

                <div class="mt-2 col-12 w-100 pt-2 fs-16 text--black fw-700">Personal Details</div>
                <!-- First Name -->
                <div class="input_container col-12 col-md-6 col-sm-6 col-left-pd mt-3">
                  <div class="flex-grow-1">
                    <div class="custom-form-v5 flex-grow-1"
                      [ngClass]="(!patientData.patient_first_name ||  patientData.patient_first_name.length === 0) && showvalidation?'has-error':''">
                      <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.patient_first_name"
                        minlength="2" maxlength=25 name="patient_first_name" required maxlength="100" />
                      <label for="text" class="label-name">
                        <span class="content-name_1 f-c-p-3">
                          First Name
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(!patientData.patient_first_name ||  patientData.patient_first_name.length === 0) && showvalidation">
                      Please enter first name</p>

                    <!-- <p class="mat-error">
                  Please enter a valid service name.</p> -->
                  </div>
                </div>
                <!-- Last Name -->
                <div class="input_container col-12 col-md-6 col-sm-6 col-right-pd mt-3">
                  <div class="flex-grow-1">
                    <div class="custom-form-v5 flex-grow-1"
                      [ngClass]="(!patientData.patient_last_name ||  patientData.patient_last_name.length === 0) && showvalidation?'has-error':''">
                      <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.patient_last_name"
                        minlength="2" maxlength=25 name="patient_last_name" required maxlength="100" />
                      <label for="text" class="label-name">
                        <span class="content-name_1 f-c-p-3">
                          Last Name
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(!patientData.patient_last_name ||  patientData.patient_last_name.length === 0) && showvalidation">
                      Please enter last name</p>

                    <!-- <p class="mat-error">
                  Please enter a valid service name.</p> -->
                  </div>
                </div>
                <div class="col-12 mt-3">
                  <div class="custom-form-v5 dob-form" [ngClass]="{'dob-able': patientData.date_of_birth}"
                    [class.has-error]="(!patientData.date_of_birth) && showvalidation || toaster_error">
                    <input (blur)="blurDataUpdate($event)" class="pointer input_field px-3 pt-3 dob-input-field" id="element" type="text"
                      [(ngModel)]="patientData.date_of_birth" mask="{{dateOfBirthMask}}" placeholder={{placeFormat}}
                      dropSpecialCharacters="true" [specialCharacters]= specialCharacter name="dob" required autocomplete="off"
                      (input)="addZero($event)" (keydown)="handleKeyDown($event)" (mousedown)="handleMouseDown($event)" (click)="handleMouseDown($event)">
                    <label style="bottom: 15px; left: 5px;" for="text" class="dob-label-name fs-12 m-0"
                      [ngClass]="[patientData.date_of_birth ? 'label-name':'']">
                      <span class="dob-content f-c-p-3 fw-600">
                        Date Of Birth
                      </span>
                      <span class="calendar-img position-absolute">
                        <!-- <img src="assets/svg/calender-2.svg" /> -->
                        <!-- <mat-datepicker-toggle matSuffix [for]="picker" class="d-none">
                      </mat-datepicker-toggle> -->
                        <!-- <mat-datepicker #picker startView="multi-year">
                        </mat-datepicker> -->
                        <!-- <img src="assets/svg/calender2.svg" class="pointer" alt=""> -->
                      </span>
                    </label>
                  </div>
                  <!-- <p class="mat-error" *ngIf="(patientData.date_of_birth.length != 10) && !showvalidation"> Please enter date of
                    birth('MM/DD/YYYY')</p> -->
                    <p class="mat-error" *ngIf="toaster_error">{{toaster_error}} </p>



                  <!-- <div class="custom-form-v5 flex-grow-1" class='custom-form-v5 mt-2'>
                  <input required name="dob" readonly class="input_field form-control pt-4 pointer"
                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY' }" (onShown)="onShowPicker($event)"
                    #dobdp="bsDatepicker" bsDatepicker required [(ngModel)]="patientData.date_of_birth"
                    [maxDate]="maxDate" [minDate]="minDate">
                  <label for="text" [ngClass]="[patientData.date_of_birth ? 'label-name':'']">
                    <span class="content-name_1 f-c-p-3">
                      Date Of Birth
                    </span>
                    <span style="position: absolute;right: 0;transform: translate(-18px, 24px)" (click)="toggle(dobdp)"
                      [attr.aria-expanded]="dobdp.isOpen">
                      <img src="../../../../assets/svg/calendar2.svg" class="pointer" alt="">
                    </span>
                  </label>
                </div> -->
                </div>

                <div class="col-12 mt-3">
                  <div class="d-sm-flex align-items-center flex-wrap prsonal-info-system">
                    <span class="color-blue-black fw-400 fs-14 gender-title d-block d-sm-inline mb-sm-0 mb-2">Gender:
                    </span>
                    <span class="min-change ps-sm-4 ps-1 py-2">
                      <span
                        class="custom-radio-box left-radio-input position-relative custom-radio-checkobx yes-personal me-4">
                        <input type="radio" id="Male" class="d-none" [checked]="patientData.patient_gender == 1"
                          name="patient_gender" (change)="changeFields('patient_gender',1)"
                          (click)="changeFields('patient_gender',1)" value="1">
                        <label class="mb-0 radio-label fw-700" for="Male" id="male">Male</label>
                      </span>
                      <span
                        class="custom-radio-box left-radio-input position-relative custom-radio-checkobx yes-personal me-4">
                        <input type="radio" id="Female" class="d-none" [checked]="patientData.patient_gender == 2"
                          name="patient_gender" (change)="changeFields('patient_gender',2)"
                          (click)="changeFields('patient_gender',2)" value="2">
                        <label class="mb-0 radio-label fw-700" for="Female" id="female">Female</label>
                      </span>
                      <span
                        class="custom-radio-box left-radio-input position-relative custom-radio-checkobx yes-personal">
                        <input type="radio" id="other" class="d-none" [checked]="patientData.patient_gender == 3"
                          name="patient_gender" (change)="changeFields('patient_gender',3)"
                          (click)="changeFields('patient_gender',3)" value="3">
                        <label class="mb-0 radio-label fw-700" for="other" id="other">Other</label>
                      </span>
                    </span>
                  </div>
                  <p class="mat-error" *ngIf="(!patientData.patient_gender) && showvalidation"> Please select gender</p>

                </div>


                <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                  <div class="flex-grow-1">
                    <div class="custom-form-v5 flex-grow-1 d-flex align-items-center"
                      [ngClass]="((patientData?.dl_number?.length < regexMode?.min || this.patientData?.dl_number?.length > regexMode?.max) && showvalidation) || Dlshowvalidation?'has-error':''">
                      <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.dl_number" name="dl_number" (input)="regexCheck($event)" [maxlength]="regexMode?.max" [minlength]="regexMode?.min" (keydown.space)="$event.preventDefault();" required />
                      <label for="text" class="label-name">
                        <span class="content-name_1 f-c-p-3">
                          Government-Issued ID Number
                        </span>
                      </label>
                      <span class="ms-n5"
                      [tooltip]="'Number from your government-issued ID, such as a Driver’s License, Passport, or any official identification document.'"
                        [customClass]="'dark-theme-tooltip'" [placement]="'right'">
                        <img src="assets/svg/icons.svg" class="" alt="info icon">
                      </span>
                    </div>
                    <p class="mat-error"
                      *ngIf="((patientData?.dl_number?.length < regexMode?.min || this.patientData?.dl_number?.length > regexMode?.max) && showvalidation && !Dlshowvalidation)"> Please
                      enter Government-Issued ID Number</p>
                    <p class="mat-error" *ngIf="Dlshowvalidation"> Please
                      enter valid Government-Issued ID Number</p>
                  </div>
                </div>


                <div class="col-md-12 col-sm-12 col-xs-12 mt-4"
                  *ngIf="planInfo && planInfo.upload_customer_document && planInfo.upload_customer_document == 1">
                  <label class="fs-14 text--black fw-700">Proof of ID</label>
                  <div class="flex-grow-1" [ngClass]="{'': patientData.dl_doc && patientData.dl_doc!=null}">
                    <div class="mb-3 proof-id" [ngClass]="{'submit': patientData.dl_doc && patientData.dl_doc!=null}">
                      <!-- bg-lg-blue py-3 rounded -->
                      <div class="col-md-9" *ngIf="!patientData.dl_doc || patientData.dl_doc==null">
                        <span class="fs-14 upload-text">Please upload a clear copy of your Driver's License or another
                          government-issued proof of ID.</span>
                        <span class="fs-14" *ngIf="patientData.dl_doc && patientData.dl_doc!=null">
                          <a [href]="patientData.dl_doc" target="_blank" style="text-decoration: none;" class="me-2">
                            <img src="assets/svg/docIcon.svg" class="fs-14 fs-600 pe-3" alt="">
                            <span>Proof of ID</span>
                          </a>
                        </span>
                      </div>
                      <div class="col-6 flex-grow-1" *ngIf="patientData.dl_doc && patientData.dl_doc!=null">
                        <span>
                          <a [href]="patientData.dl_doc" target="_blank"
                            class="fs-14 fs-400 text-decoration-none color-blue-1">
                            <!-- <img src="assets/svg/docIcon.svg" class="pe-3" alt=""> -->
                            <span> {{fileName?fileName: 'Proof of ID'}}</span>
                          </a>
                        </span>
                      </div>
                      <div class="col-12 pt-3" *ngIf="!patientData.dl_doc || patientData.dl_doc==null">
                        <label class="fs-16 fw-700 choose-file-btn pointer" for="fileInput">
                          Upload
                          <!-- <button type="button" class="button-login color-blue fw-600 bg-white px-5 border-blue"> Upload </button> -->
                        </label>
                        <input class="d-none upload" name="profilePic" id="fileInput" accept="image/*,.pdf" #fileUpload
                          type="file" name="imgUploader" (change)="fileChangeEvent($event)"
                          (click)="onFileInputClick($event)">
                      </div>
                      <div class="col-6 flex-grow-1 text-end" *ngIf="patientData.dl_doc && patientData.dl_doc!=null">
                        <span>
                          <img src="assets/svg/delete-icon.svg" class="pointer personal-delete-icon" alt=""
                            (click)="deleteDocPopUp(patientData.dl_id)" />
                        </span>
                      </div>
                    </div>
                  </div>

                  <p class="mat-error" *ngIf="(!patientData.dl_doc) && showvalidation"> Please upload document</p>

                </div>
              </div>

              <div class="button_box">
                <button button-primary-auth class="fs-16" type="submit" id="continue6">
                  Continue
                </button>
              </div>

              <footer class="footer text-center d-none">
                <div class="col-12 mt-2 mt-sm-0 Powered form-powerd--wrap">
                  <span class="footer-help--wrap--v2">
                    <span class="m-0 f-s-16 small-mob color-gray fw-700">
                      <a class="" href="https://www.credee.com/support" target="_blank"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <g clip-path="url(#clip0_8693_20253)">
                            <path
                              d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                              fill="#20A9D3" />
                          </g>
                          <defs>
                            <clipPath id="clip0_8693_20253">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg> Need Help</a>
                    </span>
                  </span>
                  <div class="w-100 small-mob mt-2 mb-3">
                    <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                          src="assets/svg/logo_colored.svg"></span></span>
                  </div>
                </div>
                <div class="text-big">
                  <span class="small-mob footer-terms--date">
                    &copy; {{date | date:'yyyy'}} - Credee
                  </span>
                </div>
              </footer>
            </form>

          </ng-container>

          <!-- step 2 details -->
          <ng-container *ngIf="current_step == 7">
            <div class="input_containers_head fw-700 fs-18 mb-0 card-body p-0 text--black ms-4">
              Employment Information
            </div>
            <form #personal_page2="ngForm" (keydown.enter)="submitPersonalDetails(personal_page2)"
              (ngSubmit)="submitPersonalDetails(personal_page2)" class="form-part"
              [ngClass]="current_step == 7 ? 'personal-infotech' : ''">
              <div class="is_customer_minor -mt-lg-0 mt-2">
                <div class="py-3 px-sm-0 px-1 d-md-flex align-items-center flex-wrap">
                  <div class="pe-4">
                    <p class="m-0 p-0 color-blue-black fw-600 personal-info-title d-lg-inline-block d-block">Are you
                      Employed?</p>
                  </div>
                  <div class="flex_added pt-3 pt-md-0 ps-md-0 ps-1">
                    <span class="custom-radio-box position-relative custom-radio-checkobx left-radio-input px-0">
                      <input type="radio" (change)="removeZip(1)" id="yes_employed" class="d-none"
                        [checked]="employer_yes_id == 1" name="is_minor" value="1">
                      <label class="mb-0 color-blue-black fw-700 fs-14 radio-label" for="yes_employed" id="yes_employed">Yes</label>
                    </span>
                    <span class="custom-radio-box position-relative custom-radio-checkobx left-radio-input px-0 ms-4">
                      <input type="radio" (change)="removeZip(0)" id="not_employed" class="d-none"
                        [checked]="employer_yes_id == 0" name="is_minor" value="0">
                      <label class="mb-0 color-blue-black fw-700 fs-14 radio-label" for="not_employed" id="not_employed">No</label>
                    </span>
                    <span class="custom-radio-box position-relative custom-radio-checkobx left-radio-input px-0 ms-4">
                      <input type="radio" (change)="removeZip(2)" id="self_employed" class="d-none"
                        [checked]="employer_yes_id == 2" name="is_minor" value="2">
                      <label class="mb-0 color-blue-black fw-700 fs-14 radio-label" for="self_employed" id="self_employed">Self
                        Employed</label>
                    </span>
                  </div>
                </div>
              </div>

              <div class="row height__wrapper height__wrapper_v2">
                <ng-container *ngIf="employer_yes_id == 1">
                  <!-- <span class="w-100 fs-18 py-2 px-3 color-gray">Personal Details</span> -->
                  <!-- First Name -->
                  <div class="input_container col-12 col-md-12 col-sm-12 mt-1">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1">
                        <input type="text" class="input_field px-3 pt-3" #employerName="ngModel" name="employerName"
                          [(ngModel)]="patientData.employer_name" minlength="2" maxlength=100 name="employer_name"
                          required maxlength="100" [ngClass]="{
                          'black-border': patientData.employer_name,
                          'normal-border': !patientData.employer_name,
                          'has-error': (!patientData.employer_name || patientData.employer_name.length == 0) && showvalidation
                      }" />
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3">
                            Employer Name*
                          </span>
                        </label>
                      </div>
                      <!-- <p class="mat-error">
                    Please enter a valid service name.</p> -->
                      <p class="mat-error"
                        *ngIf="(!patientData.employer_name || patientData.employer_name.length == 0) && showvalidation">
                        Please enter employer name</p>
                    </div>
                  </div>
                  <!-- Phone Number -->
                  <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1" [ngClass]="{
                      'black-border': patientData.employer_mobile,
                      'normal-border': !patientData.employer_mobile,
                      'has-error':(!patientData.employer_mobile  || patientData.employer_mobile.length == 0) && showvalidation
                  }">
                        <mat-select disabled id="img_logo_emp"
                          class="flag_dropdown input_field font-weight-bold m-h-52 h-100 w-100" #countryCode="ngModel"
                          name="countryCode" [(ngModel)]="patientData.employer_mobile_country_code"
                          [ngModelOptions]="{standalone: true}">
                          <mat-select-trigger>
                            <!-- <img style="width: 2.5rem;" src="assets/svg/country_flag/{{flag_code}}_flag.svg" > -->
                            <span> {{patientData.employer_mobile_country_code}} </span>
                          </mat-select-trigger>
                          <mat-option *ngFor="let option of mainService.mobile_code_arr;let i=index" [value]="option">
                            <!-- <img style="width: 1.33333333em;" src="assets/svg/country_flag/{{option.country_code | lowercase}}_flag.svg" > -->
                            <span class="ps-2" style="color: #8c8989;">{{option}}</span>
                          </mat-option>
                        </mat-select>
                        <input type="text" class="input_field pe-3 pt-3 mobile-field-patient" #employerPhone="ngModel"
                          name="employerPhone" [(ngModel)]="patientData.employer_mobile" minlength=6
                          required  [mask]="mask"/>
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3 phone-number-pos">
                            Employer Phone Number*
                          </span>
                        </label>
                      </div>

                      <p class="mat-error"
                        *ngIf="(!patientData.employer_mobile  || patientData.employer_mobile.length == 0) && showvalidation">
                        Please enter Employer Phone Number</p>
                    </div>
                  </div>

                  <!-- address -->
                  <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                    <app-google-api (setAddress)="getZipselected($event,2)" [t]="1" [customClass]="['custom-form-v5']"
                      [isRequired]="true" id="zipPostalCode" name="zipPostalCode" label="Employer Address*"
                      [model]="patientData.employer_address" ngDefaultControl [defaultzip]="empzip">
                    </app-google-api>
                    <p class="mat-error"
                      *ngIf="(!patientData.employer_address || patientData.employer_address.length == 0) && showvalidation">
                      Please enter Employer address</p>
                  </div>

                  <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1">
                        <input type="text" class="input_field px-3 pt-3" #employer_address_2="ngModel" name="employer_address_2"
                          [(ngModel)]="patientData.employer_address_2" maxlength=100 name="employer_address_2"
                          maxlength="100" [ngClass]="{
                          'black-border': patientData.employer_address_2,
                          'normal-border': !patientData.employer_address_2
                      }" />
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3">
                            Employer Address Line 2 (Optional)
                          </span>
                        </label>
                      </div>                      
                    </div>
                  </div>

                  <!-- ZIP Code -->
                  <div class="col-12 col-sm-12 mt-3" [ngClass]="{
                  'google-black': patientData.employer_address,
                  'after-field': !patientData.employer_address, 
                  'show-error': (!patientData.employer_address || patientData.employer_address.length == 0) && showvalidation
              }">
              <div class="flex-grow-1">
                <div class="custom-form-v5 flex-grow-1">
                  <input type="text" class="input_field px-3 pt-3" #employerAddress="ngModel"
                    name="employerAddress" maxlength=100 [(ngModel)]="patientData.employer_zip" required disabled
                    [ngClass]="{
                    'black-border': patientData.employer_zip,
                    'normal-border': !patientData.employer_zip,
                    'has-error': (!patientData.employer_zip || patientData.employer_zip.length == 0) && showvalidation
                }" />
                  <label for="text" class="label-name">
                    <span class="content-name_1 f-c-p-3">
                      Employer Zip/Postal Code*
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="(!patientData.employer_zip || patientData.employer_zip.length == 0) && showvalidation">
                  Please enter Employer zip/postal Code</p>

                <!-- <p class="mat-error">
              Please enter a valid service name.</p> -->
              </div>

                  </div>

                  <!-- state and city -->
                  <div class="input_container col-12 col-md-6 col-sm-6 col-left-pd mt-3">

                    <div class="custom-form-v5 flex-grow-1">
                      <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.employer_state"
                        #employerState="ngModel" minlength="2" maxlength=25 name="employerState" required disabled
                        [ngClass]="{
                        'black-border': patientData.employer_state,
                        'normal-border': !patientData.employer_state,
                        'has-error': (!patientData.employer_state || patientData.employer_state.length == 0) && showvalidation
                    }" />
                      <label for="text" [ngClass]="[patientData.employer_state ? 'label-name' : '']">
                        <span class="content-name_1 f-c-p-3">
                          State / Province
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(!patientData.employer_state || patientData.employer_state.length == 0) && showvalidation">
                      Please enter State / Province</p>

                    <!-- <p class="mat-error">
                      Please enter a valid service name.</p> -->

                  </div>
                  <!-- state and city -->
                  <div class="input_container col-12 col-md-6 col-sm-6 col-right-pd mt-3">

                    <div class="custom-form-v5 flex-grow-1">
                      <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.employer_city"
                        #employerCity="ngModel" minlength="2" maxlength=25 name="employerCity" required disabled
                        [ngClass]="{
                        'black-border': patientData.employer_city,
                        'normal-border': !patientData.employer_city,
                        'has-error': (!patientData.employer_city || patientData.employer_city.length == 0) && showvalidation
                    }" />
                      <label for="text" [ngClass]="[patientData.employer_city ? 'label-name' : '']">
                        <span class="content-name_1 f-c-p-3">
                          City
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(!patientData.employer_city || patientData.employer_city.length == 0) && showvalidation">
                      Please enter city</p>

                    <!-- <p class="mat-error">
                      Please enter a valid service name.</p> -->

                  </div>


                  <!-- annual income  -->
                  <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1 position-relative">
                        <span *ngIf="patientData.annual_income" class="fs-16 fw-400 position-absolute"
                          style="top: 23px;left: 14px;">{{mainService.currency_data.display_logo}}</span>
                        <input type="text" class="input_field px-3 pt-3" #annualIncome="ngModel" name="annualIncome"
                          (keypress)="enterNumberOnly($event)" [(ngModel)]="patientData.annual_income" maxlength='7'
                          step="01" required [class.greaterone]="mainService.currency_data.display_logo.length>1"
                          [ngClass]="{
                          'black-border income_margin': patientData.annual_income,
                          'normal-border': !patientData.annual_income,
                          'has-error': (!patientData.annual_income ||  patientData.annual_income.length == 0) && showvalidation
                      }" />
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3">
                            Annual Income*
                          </span>
                        </label>
                      </div>
                      <p class="mat-error"
                        *ngIf="(!patientData.annual_income ||  patientData.annual_income.length == 0) && showvalidation">
                        Please enter Annual Income</p>

                      <!-- <p class="mat-error">
                    Please enter a valid service name.</p> -->
                    </div>
                  </div>

                </ng-container>

                <ng-container *ngIf="employer_yes_id == 2">
                  <!-- <span class="w-100 fs-18 py-2 px-3 color-gray">Personal Details</span> -->
                  <!-- First Name -->
                  <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1">
                        <input type="text" class="input_field px-3 pt-3" #profession="ngModel" name="profession"
                          [(ngModel)]="patientData.profession" minlength="2" maxlength=100 name="employer_name" required
                          maxlength="100" trim="true" [ngClass]="{
                          'black-border': patientData.profession,
                          'normal-border': !patientData.profession,
                          'has-error': profession.invalid &&
                          (profession.touched || patientData.submitted)
                      }" />
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3">
                            Profession*
                          </span>
                        </label>
                      </div>
                      <p class="mat-error"
                        *ngIf="(!patientData.profession|| patientData.profession.length == 0) && showvalidation"> Please
                        enter Profession</p>

                      <!-- <p class="mat-error">
                    Please enter a valid service name.</p> -->
                    </div>
                  </div>
                  <!-- Office Address -->
                  <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                    <app-google-api (setAddress)="getZipselected($event,3)" [t]="1" [customClass]="['custom-form-v5']"
                    [isRequired]="true" id="zipPostalCode" name="zipPostalCode" label="Office Address*"
                    [model]="patientData.office_address" ngDefaultControl [defaultzip]="ofczip">
                  </app-google-api>
                  <p class="mat-error"
                    *ngIf="(!patientData.office_address || patientData.office_address.length == 0) && showvalidation">
                    Please enter address</p>
                  </div>
                  <div class="col-12 mt-3">
                    <div class="checkbox c-checkbox pay-check custom-checkbox -pay-check-left">

                      <input type="checkbox" id="office_address_check" name="office_address_check"
                        class="form-check-input" [(ngModel)]="office_address_check"
                        (change)="changeOfficeAddress()" />
                      Office Address Same as Home Address. <label class="mb-0 form-check-label"
                        for="office_address_check" style="cursor: pointer"></label>
                    </div>
                  </div>
                  <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1">
                        <input type="text" class="input_field px-3 pt-3" #office_address_2="ngModel" name="office_address_2"
                          [(ngModel)]="patientData.office_address_2" maxlength=100 name="office_address_2"
                          maxlength="100" [ngClass]="{
                          'black-border': patientData.office_address_2,
                          'normal-border': !patientData.office_address_2
                      }" />
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3">
                            Office Address Line 2 (Optional)
                          </span>
                        </label>
                      </div>                      
                    </div>
                  </div>


                  <!-- ZIP Code -->
                  <div class="col-12 col-sm-12 mt-3" [ngClass]="{
                    'google-black': patientData.office_address,
                    'after-field': !patientData.office_address,
                    'show-error': (!patientData.office_address || patientData.office_address.length == 0) && showvalidation
                }">
                    <!-- <div class="input-group">
                  <input type="text" *ngIf="office_address_check" [(ngModel)]="patientData.office_zip" name="office_zip"
                    class="form-control" trim="blur" [disabled]="office_address_check">
                </div> -->
                    <!-- <zip-selector (zipSelected)="getZipselected($event,3)" [placeholder]=""
                    [customClass]="['custom-form-v5']" t="2" [isRequired]="true" id="zipPostalCode" name="zipPostalCode"
                    [model]="patientData.office_zip" ngDefaultControl label="Office zip/Postal Code*"
                    [defaultzip]="ofczip" [disabled]="office_address_check">
                  </zip-selector> -->

                  <div class="flex-grow-1">
                    <div class="custom-form-v5 flex-grow-1">
                      <input type="text" class="input_field px-3 pt-3" #office_zip="ngModel" name="office_zip"
                        [(ngModel)]="patientData.office_zip" trim="blur" required [ngClass]="{
                        'black-border': patientData.office_zip,
                        'normal-border': !patientData.office_zip,
                        'has-error': (!patientData.office_zip || patientData.office_zip.length == 0) && showvalidation
                    }"  disabled/>
                      <label for="text" class="label-name">
                        <span class="content-name_1 f-c-p-3">
                          Office Zip/Postal Code*
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(!patientData.office_zip || patientData.office_zip.length == 0) && showvalidation">
                      Please enter Office zip/postal code</p>

                    <!-- <p class="mat-error">
                  Please enter a valid service name.</p> -->
                  </div>

                  </div>


                  <!-- state and city -->
                  <div class="input_container col-12 col-md-6 col-sm-6 col-left-pd mt-3">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1">
                        <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.office_state"
                          #officeState="ngModel" minlength="2" maxlength=25 name="officeState" required disabled
                          [ngClass]="{
                          'black-border': patientData.office_state,
                          'normal-border': !patientData.office_state,
                          'has-error': (!patientData.office_state || patientData.office_state.length == 0) && showvalidation
                      }" />
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3">
                            State / Province
                          </span>
                        </label>
                      </div>
                      <p class="mat-error"
                        *ngIf="(!patientData.office_state || patientData.office_state.length == 0) && showvalidation">
                        Please enter State / Province</p>

                      <!-- <p class="mat-error">
                      Please enter a valid service name.</p> -->
                    </div>
                  </div>
                  <!-- state and city -->
                  <div class="input_container col-12 col-md-6 col-sm-6 col-right-pd mt-3">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1">
                        <input type="text" class="input_field px-3 pt-3" [(ngModel)]="patientData.office_city"
                          #officeCity="ngModel" minlength="2" maxlength=25 name="officeCity" required disabled
                          [ngClass]="{
                          'black-border': patientData.office_city,
                          'normal-border': !patientData.office_city,
                          'has-error': (!patientData.office_city || patientData.office_city.length == 0) && showvalidation
                      }" />
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3">
                            City
                          </span>
                        </label>
                      </div>
                      <p class="mat-error"
                        *ngIf="(!patientData.office_city || patientData.office_city.length == 0) && showvalidation">
                        Please enter City</p>

                      <!-- <p class="mat-error">
                      Please enter a valid service name.</p> -->
                    </div>
                  </div>


                  <!-- annual income  -->
                  <div class="input_container col-12 col-md-12 col-sm-12 mt-3">
                    <div class="flex-grow-1">
                      <div class="custom-form-v5 flex-grow-1 position-relative" style="position: relative;">
                        <span *ngIf="patientData.annual_income" style="top: 22px;left: 14px;"
                          class="font-weight-bolder fs-16 fw-400 position-absolute">{{mainService.currency_data.display_logo}}</span>
                        <input type="text" class="input_field px-3 pt-3" #annualIncome="ngModel" name="annualIncome"
                          [type]="is_android_device ? 'number' : 'text'" (keypress)="enterNumberOnly($event)"
                          maxlength='7' [(ngModel)]="patientData.annual_income" appNumberOnly required
                          [class.greaterone]="mainService.currency_data.display_logo.length>1" [ngClass]="{
                          'black-border income_margin': patientData.annual_income,
                          'normal-border': !patientData.annual_income,
                          'has-error': (!patientData.annual_income || patientData.annual_income.length == 0) && showvalidation
                      }" />
                        <label for="text" class="label-name">
                          <span class="content-name_1 f-c-p-3">
                            Annual Income*
                          </span>
                        </label>
                      </div>
                      <p class="mat-error"
                        *ngIf="(!patientData.annual_income || patientData.annual_income.length == 0) && showvalidation">
                        Please enter Annual Income</p> <!-- <p class="mat-error">
                    Please enter a valid service name.</p> -->
                    </div>
                  </div>

                </ng-container>

                <ng-container *ngIf="employer_yes_id == 0">
                  <div class="col-12 col-md-12 col-sm-12 dropdown-value">
                    <div class="wrap m-h-56 h-100 h-56 border_10 d-block mt-3">
                      <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                        <div class="w-100 h-100">
                          <select id="img_logo_emp" style="font-weight: 600!important;" [(ngModel)]="selectedValue"
                            (change)="service()" name="selectedValue"
                            class="select-text pt-3 px-3 mt-1 input_field px-3 pt-4 font-weight-bold m-h-56 h-100 w-100 color-dblue"
                            required
                            [class.has-error]="(selectedValue == null || selectedValue.trim().length == 0) && showvalidation" id="selectedValue">
                            <!-- <option class="w-100 py-3 px-2 d-none" selected>
                            </option> -->
                            <option *ngFor="let c of payment_source" [ngValue]="c.name">{{c.name}}</option>
                          </select>
                          <span class="select-highlight"></span>
                          <span class="select-bar"></span>
                          <span class="select-bar-1"></span>
                          <span class="select-bar-1"></span>
                          <label class="select-label select-label--modify f-c-p-3 fs-14" style="color: #596775;">
                            How are you planning to pay
                            for the services?
                          </label>
                        </div>
                      </div>
                      <p class="mat-error"
                        *ngIf="(selectedValue == null || selectedValue.trim().length == 0) && showvalidation"> Please
                        select option</p>
                    </div>
                  </div>
                  <div class="col-12 col-md-12 col-sm-12 mt-3" *ngIf="selectedValue == 'Others'">
                    <div class="custom-form-v5 flex-grow-1">
                      <input type="text" class="input_field px-3 pt-3" #otherservicevalue="ngModel" maxlength="300"
                        [(ngModel)]="other_service_value" name="other_service_value" name="other_service_value" required
                        maxlength="100" [ngClass]="{
                          'black-border': other_service_value,
                          'normal-border': !other_service_value,
                          'has-error': (!other_service_value || other_service_value.trim().length == 0) && showvalidation
                      }" />
                      <label for="text" class="label-name">
                        <span class="content-name_1 f-c-p-3">
                          Payback Source Name
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(!other_service_value || other_service_value.trim().length == 0) && showvalidation"> Please
                      select valid Payback Source Name</p>

                  </div>
                </ng-container>
              </div>

              <div class="button_box mt-4">
                <button button-primary-auth class="fs-16" id="update_patient">
                  Update Now
                </button>
              </div>
              <footer class="footer text-center d-md-none">
                <div class="col-12 mt-2 mt-sm-0 Powered form-powerd--wrap">
                  <span class="footer-help--wrap--v2">
                    <span class="m-0 f-s-16 small-mob color-gray fw-700">
                      <a class="" href="https://www.credee.com/support" target="_blank"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <g clip-path="url(#clip0_8693_20253)">
                            <path
                              d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                              fill="#20A9D3" />
                          </g>
                          <defs>
                            <clipPath id="clip0_8693_20253">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg> Need Help</a>
                    </span>
                  </span>
                  <div class="w-100 small-mob mt-2 mb-3">
                    <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                          src="assets/svg/logo_colored.svg"></span></span>
                  </div>
                </div>
                <div class="text-big">
                  <span class="small-mob footer-terms--date">
                    &copy; {{date | date:'yyyy'}} - Credee
                  </span>
                </div>
              </footer>
            </form>

          </ng-container>

          <ng-container *ngIf="current_step == 5">
            <div class="form-inside px-xl-4 px-2 onestep-modal" id="fully-successfull">
              <div class="modal-body p-0">
                <div class="modal-data">
                  <div class="success-animation success-md-animation mt-3">
                    <img src="assets\png\check-icon.png" alt="">
                  </div>
                  <div class="head_content py-2 mb-md-3 mb-0 h5 fw-700 fs-18">
                    Contract has been Created successfully.
                    <p class="fs-12 fw-700 contract_id_grey">
                      CONTRACT ID: {{planInfo['contract_code'] || contract_code || 'Not Available'}}
                    </p>
                  </div>
                </div>

                <div class="body_content px-0">
                  <div class="w-100 pay-plan p-0">
                    <div class="plans--commit d-flex align-items-center flex-grow-1 info-card">
                      <div class="flex-grow-1">
                        <p class="plans-commit-text m-0 fs-18 fw-400 mb-1 text-start">
                          Payment Plan
                        </p>
                        <p class="fs-20 py-1 fw-800 m-0 text-start plans-commit--price" *ngIf="planInfo">
                          {{mainService.currency_data.display_logo}} {{planInfo && planInfo.treatment_amount ?
                          ((planInfo.treatment_amount - (planInfo.downpayment_amount || 0))|DynamicDecimalPipe:mainService.currency_data.currency_code) :'0.00'}}</p>
                      </div>
                    </div>
                    <div class="plans--commit plan-left-border info-card-two d-flex align-items-center flex-grow-1"
                      *ngIf="planInfo && planInfo.contract_type != 6">
                      <div class="flex-grow-1">
                        <p class="plans-commit-text mb-1 fs-18 fw-400 text-start">{{planInfo && planInfo.selected_plan
                          &&
                          planInfo.selected_plan.month}} Months</p>
                        <div class="per_month py-1 card-track2 text-start fs-20 fw-800 plans-commit--price">
                          {{mainService.currency_data.display_logo}} {{planInfo && (planInfo?.recurring_amount ||
                          planInfo.selected_plan?.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                          <span class="card-track1 fs-14 fw-400 plans-commit--month">per month</span>
                        </div>
                      </div>
                    </div>
                    <div class="flex-grow-1 ps-4" *ngIf="planInfo && planInfo.contract_type == 6">
                      <div class="flex-grow-1 plans--commit-innr">
                        <div class="mb-3 plans--commit plan-left-border d-flex align-items-center">
                          <div class="flex-grow-1">
                            <p class="plans-commit-text mb-1 fs-18 fw-400 text-start">{{ !(planInfo && (planInfo.number_of_payments > planInfo.deferred_duration)) ? 'Recurring Amount' : 'First'+ planInfo.deferred_duration +'Months'}} </p>
                            <div class="per_month py-1 fs-20 fw-800 text-start fw-800 plans-commit--price">
                              {{mainService.currency_data.display_logo}} {{planInfo && (planInfo.recurring_amount ||
                              planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                              <span class="color-gray-2 fw-400 fs-14 text-start fw-400 plans-commit--month">/
                                month</span>
                            </div>
                          </div>
                        </div>
      
                        <div class="flex-grow-1 plans--commit plan-left-border d-flex align-items-center" *ngIf="(planInfo && (planInfo.number_of_payments > planInfo.deferred_duration))">
                          <div class="flex-grow-1">
                            <p class="plans-commit-text mb-1 fs-18 fw-400 text-start">Remaining Months</p>
                            <div class="per_month py-1 fs-20 fw-800 text-start fw-800 plans-commit--price">
                              {{mainService.currency_data.display_logo}} {{planInfo && (planInfo.next_recurring_amount
                              ||
                              planInfo.selected_plan.next_recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                              <span class="color-gray-2 fw-400 fs-14 text-start fw-400 plans-commit--month">/
                                month</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="w-100 recurring">
                    <span class="card-body first-occur">First Recurring Payment Date</span>
                    <p class="date_column h3 mt-2 fw-700">{{mainService.getDatePlan(paymentDetails)}}
                    </p>
                  </div>

                  <div class="w-100 d-flex button__Wrapper" style=" justify-content: space-between;">
                    <div class="text-end mt-md-3 flex-grow-1 contract-wrap pe-sm-2">
                      <button class=" pointer btn w-100" (click)="downloadContract()">Download Contract</button>
                    </div>
                    <div class="text-start mt-md-3 flex-grow-1 contract-wrap1 ps-md-3 ps-sm-2">
                      <button class=" pointer btn w-100" (click)="continueLogin()">Login to Dashbord</button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </ng-container>

          <!-- footer -->
          <!-- <div class="w-100 d-none text-center footer_insied_out mt-3">
          <footer class="footer text-justify">
            <div class="text-big">
              <span
                *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
                <span class="m-0 f-s-16 small-mob color-gray">
                  In case of any additional queries, please contact your service provider
                  <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
                    '+planInfo.doctor_last_name}}</b>
                  <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at
                  </span>
                  <a class="text-bold"
                    *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
                    href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
                    {{planInfo && planInfo.practice_mobile ?(planInfo.practice_mobile | phoneNumber) :
                    (planInfo.doctor_phone | phoneNumber) ? (planInfo.doctor_phone | phoneNumber) :
                    (planInfo.doctor_mobile | phoneNumber)}}
                  </a>
                </span>
              </span>
              <span
                *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport">
                <span class="m-0 f-s-16 small-mob color-gray fw-700">
                  Need Help? <a class="text-bold" style="color: #1581E5" href="https://www.credee.com/support"
                    target="_blank">Click Here</a> to contact Credee
                  Support
                </span>
              </span>
              <span class="small-mob">
                &copy; {{date | date:'yyyy'}} - Credee
              </span>
            </div>
          </footer>
        </div> -->
        </div>
        <span class="footer-help--wrap--modify" *ngIf="!mainService?.support_data?.support_mobile">
          <span class="m-0 f-s-16 small-mob color-gray fw-700">
            <a class="" style="color: #017A9F" href="https://www.credee.com/support" target="_blank"><svg
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_8693_20253)">
                  <path
                    d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                    fill="#20A9D3" />
                </g>
                <defs>
                  <clipPath id="clip0_8693_20253">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg> Need Help</a>
          </span>
        </span>
      </div>
    </div>
    
  </div>
  <footer class="footer d-none d-md-block" *ngIf="!mainService?.support_data?.support_mobile">
    <div class="col-12 mt-2 mt-sm-0 Powered form-powerd--wrap">
      <div class="w-100 small-mob">
        <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
              src="assets/svg/logo_colored.svg"></span></span>
      </div>
    </div>
    <div class="text-big">
      <span class="small-mob footer-terms--date">
        &copy; {{date | date:'yyyy'}} - Credee
      </span>
    </div>
  </footer>
  <footer class="footer d-none d-md-block fixed-bottom mb-3">
    <div class="mb-2 text-center text-muted fs-16" *ngIf="mainService.support_data && mainService.support_data.support_mobile">
      Need Help? &nbsp; Call us at <span><a highlight-color href="tel:{{mainService.support_data.support_mobile}}">{{mainService.support_data.support_mobile}}</a></span>, or <span><a highlight-color href="https://www.credee.com/support" target="_blank">Click here</a></span> to Request a Callback.
    </div>
    <div class="d-flex justify-content-center align-items-center py-1">
      <div class="mt-2 mt-sm-0 mr-2 Powered">
        <div class="w-100 small-mob text-muted">
          <span class="fs-14 ">Powered By <span class="text-primary ml-1"><img
                src="assets/svg/logo_colored.svg"></span></span>
        </div>
      </div>
      <div class="text-big">
        <span class="small-mob text-muted">
          &copy; {{date | date:'yyyy'}} - Credee
        </span>
      </div>
    </div>
  </footer>

</div>

<div bsModal #paymentModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="row p-0 ps-3 w-100 text-center">
          <h3>Self Verification</h3>
        </div>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <h2 style="padding-top: 15px;">Choose your way to login into the system</h2>
          <div style="padding: 15px 0;">
            <div>
              <span class="surface-img">
                <img class="mt-3" src="./assets/svg/surface1.svg" />
              </span>
            </div>
            <div class="text-div" style="margin-top: -30px;" (click)="openApp()">
              <h4 class="offset-sm-3 col-sm-6 panel-icon text-bold">Customer Mobile App</h4>
            </div>
          </div>
          <div class="panel-text">
            <h5 class="text-bold">
              <span class="text-muted">Or Via</span>
              <a (click)="openPanel()" style="color: #4dd3ae;"> Credee WEB PORTAL</a>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>